export class TokenFormModel {
  token_val: string;
  expire: Date;
  app_hotel_id: number;
  app_hotels: string;
  name: string;
  last_name: string;
  role: string;
  job_title: string;
  email: string;
  language_code: string;
  mobile_phone: string;
  user_status: number;
  cc_email_address: string;
  id: number;
  guest_visible: boolean;


  constructor(token_val: string,
    expire: Date,
    app_hotel_id: number,
    app_hotels: string,
    name: string,
    last_name: string,
    role: string,
    job_title: string,
    email: string,
    language_code: string,
    mobile_phone: string,
    user_status: number,
    cc_email_address: string) {
    this.token_val = token_val;
    this.expire = expire;
    this.app_hotel_id = app_hotel_id;
    this.app_hotels = app_hotels;
    this.name = name;
    this.last_name = last_name;
    this.role = role;
    this.job_title = job_title;
    this.email = email;
    this.language_code = language_code;
    this.mobile_phone = mobile_phone;
    this.user_status = user_status;
    this.cc_email_address = cc_email_address;
  }

}
